


/**
 * The global definition of the API URL may not be defined in
 * unit tests, so this returns either the defined on eor the
 * dev url.
 *
 * It contains https:// but not the trailing /
 */
export function getApiUrl(): string {
    const defaultUrl = "https://dev-api.xapp.media";

    try {
        return window.xaStudioConfig?.apiUrl || defaultUrl;
    } catch (e) {
        console.warn(`error getting default apiUrl`);
        console.error(e);
        return defaultUrl;
    }
}

/**
 * Router socket URL.
 *
 * Contains wss:// but no trailing /
 */
export function getRouterUrl(): string {
    const defaultUrl = "wss://routerws.xapp.ai";

    try {
        return window.xaStudioConfig?.routerWSUrl || defaultUrl;
    } catch (e) {
        console.warn(`error getting default apiUrl`);
        console.error(e);
        return defaultUrl;
    }
}